import React from 'react';
import VideoThumbnailCard from '../../../../components/VideoThumbnailCard';
import { ShortContentView } from '../../../../../Pages/VideoPlayer/utils/queryParamsKeys';
import VideoCardPlaylist from '../../../../components/VideoCardPlaylist';

const PlaylistGrid = ({ playlist, hasSubscription, savedVideos, onSaveUnsave }) => {
	if (!playlist?.videos || !Array.isArray(playlist.videos) || playlist.videos.length === 0) {
		return <div className="col-12 text-center py-3">No videos in this playlist</div>;
	}

	return (
		<div className="p-0">

			<div>
				{playlist.videos.map((video, index) => (
					<div key={`${video._id}-${index}`} className="mb-2">
						<VideoCardPlaylist
							key={`${video._id}-${index}`}
							video={video}
							playlistId={playlist._id}
							isLiked={savedVideos.includes(video._id)}
							viewType={ShortContentView.FEATURED}
							fld={playlist}
							showAddToPlaylist={false}
							showSaveButton={false}
							handleSaveUnsave={onSaveUnsave}
							titleStyles={{ fontSize: 'clamp(1.15rem, 1.2vw, 1.6rem)' }}
						/>
					</div>
				))}
			</div>

		</div>
	);
};

export default PlaylistGrid;
